import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button } from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Poppers from "@mui/material/Popper";
import { ConvertMprcColorsToString } from "components";
import * as React from "react";
import { useState } from "react";
import { HeaderLinksStyle } from "./styles";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    refEl: Nullable<HTMLElement>;
}

interface IProps {
    children?: React.ReactNode;
    iconOrUrl: IconProp | string;
    notificationIcon?: IconProp;
    notificationIconSize?: SizeProp;
    notificationIconColor?: MprcColorsExtended;
    accessKey?: string;
    tooltip?: string;
    open: boolean;
    handleClose: (e: MouseEvent | TouchEvent) => void;
    handleToggle: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////////////////

export const HeaderLinkButton: React.FC<IProps> = (props) => {
    const [state, setState] = useState<IState>({ refEl: null });
    const { classes, cx } = HeaderLinksStyle();
    const { accessKey, iconOrUrl, notificationIcon, notificationIconColor = "warning", notificationIconSize = "1x", open, tooltip, children } = props;

    function handleOuterClick(event: MouseEvent | TouchEvent) {
        const target = event.target as HTMLElement;

        if (state.refEl?.contains(target)) {
            return;
        }

        props.handleClose(event);
    }

    return (
        <div className={classes.buttonContainer} title={tooltip}>
            <Button
                variant="text"
                aria-expanded={open}
                aria-haspopup="true"
                accessKey={accessKey}
                onClick={
                    (e) => {
                        setState({ refEl: e.currentTarget });
                        props.handleToggle();
                    }
                }
                className={classes.buttonMenu}
            >
                {
                    typeof (iconOrUrl) == "string"
                        ? <img src={iconOrUrl as string} width={40} height={40} key={"HeaderUserImg"} alt={tooltip} />
                        : <FontAwesomeIcon icon={iconOrUrl} fixedWidth fontSize="22px" />
                }
                {
                    notificationIcon && (
                        <Box
                            className={classes.buttonPriorityCounter}
                            sx={(theme) => ({ color: ConvertMprcColorsToString(theme, notificationIconColor) })}
                        >
                            <FontAwesomeIcon icon={notificationIcon} size={notificationIconSize} />
                        </Box>
                    )
                }
            </Button>
            <Poppers
                open={open}
                anchorEl={state.refEl}
                transition
                disablePortal
                className={cx(classes.popperNav, { [classes.popperClose]: !open })}
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={
                            {
                                transformOrigin: placement === "bottom" ? "center top" : "center bottom"
                            }
                        }
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleOuterClick}>
                                <div>
                                    {children}
                                </div>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Poppers>
        </div>
    );
};
